import { StyleSheet } from 'aphrodite';
import { brandPrimary, white } from '../../styles/colors';

export const styleSheet = StyleSheet.create({
	root: {
		display: 'grid',
		gridTemplateColumns: '1fr auto',
		height: '100%',
		justifyItems: 'center',
	},
	layer: {
		background: '#fff',
		borderRadius: 10,
		display: 'flex',
		minHeight: '90%',
		width: '100%',
	},
	layer1: {
		marginTop: 20,
		position: 'relative',
	},
	layer2: {
		top: 10,
		width: 'calc(100% - 20px)',
	},
	layer3: {
		top: 0,
		width: 'calc(100% - 40px)',
	},
	queueRoot: {
		paddingTop: 32,
		height: '100%',
		width: '100%',
		display: 'grid',
		justifyItems: 'center',
		overflowY: 'hidden',
		overflowX: 'auto',
	},
	queueContainer: {
		display: 'flex',
		justifyContent: 'center',
		minWidth: 1024,
		maxWidth: 1400,
		paddingBottom: 20,
		boxSizing: 'border-box',
		position: 'relative',
		paddingLeft: 16,
		paddingRight: 16,
		height: '100%',
		width: '100%',
		overflow: 'hidden',
	},
	sunShade: {
		alignItems: 'center',
		background: brandPrimary,
		borderRadius: 10,
		color: white,
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		justifyContent: 'center',
		left: 0,
		top: 0,
		width: '100%',
		zIndex: 9999999999,
	},
	transparentLayer: {
		left: '50%',
		opacity: 0.4,
		position: 'absolute',
		transform: 'translate(-50%, 0)',
	},
	drawer: {
		overflow: 'hidden',
	},
	drawerContent: {
		paddingBottom: 24,
		overflow: 'hidden',
	},
	settingsPanel: {
		padding: 20,
	},
	settingsPanelTitle: {
		fontSize: 16,
		fontWeight: 600,
		marginBottom: 16,
		marginTop: 0,
	},
});
